import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import AppConnector from '../../AppConnector'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    
    this.GS = new GlobalStorage();
    this.connector = new AppConnector();
    this.onSubmit = this.onSubmit.bind(this);    
    this.state = {
      
    }

    this.warningList = this.GS.getStory().warningList;
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }


  toggleCheckbox(label)
  {
    if (this.warningList.has(label)) {
      this.warningList.delete(label);
    } else {
      this.warningList.add(label);
    }
  
  }

  onSubmit()
  {
    this.connector.createStory(()=>{
      alert("已創立故事！馬上創立故事章節！")
      this.props.toggleModalState('createEpisode');
    },1);                      
  }

  render()
  {
    return (
      <div>
      <ModalHeader toggle={()=>{this.props.toggleModal()}}>故事細節</ModalHeader>
      <ModalBody>
        請輸入故事名稱和故事類別：
        <InputGroup>          
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01">故事名稱</label>
          </div>
          <Input 
            id="storyname" 
            value={this.GS.getStory().storyName}
            onChange={(e) => {
              this.GS.getStory().storyName = e.target.value;
              this.forceUpdate();
            }}
          />
        </InputGroup>                
        <InputGroup>          
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01">作者名稱</label>
          </div>
          <Input 
            id="author" 
            value={this.GS.getStory().author}
            onChange={(e) => {
              this.GS.getStory().author = e.target.value;
              this.forceUpdate();
            }}
          />
        </InputGroup>                
        <InputGroup>         
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01">故事簡介</label>
          </div>         
          <textarea
              rows="5" 
              className={"form-control"}
              value={this.GS.getStory().description}
              onChange={(e) => {
                this.GS.getStory().description = e.target.value;
                this.forceUpdate();
              }}
            />
        </InputGroup>
        <InputGroup>                                                        
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01">故事類別</label>
          </div>
          
          <Input type="select" name="select" className="custom-select"   
            value={this.GS.getStory().category}
            onChange={(e) => {
              this.GS.getStory().category = e.target.value;
              this.forceUpdate();
            }}
          >
            <option value={'ROMANCE'}>{'愛 Love & Romance'}</option>
            <option value={'SCIENCE_FICTION'}>{'幻 Sci-Fi'}</option>
            <option value={'MYSTERY'}>{'懸 Thriller'}</option>    
            <option value={'COMEDY'}>{'喜 Comedy'}</option>
            <option value={'HORROR'}>{'動 Action'}</option>
            <option value={'CHINESE_MARTIAL'}>{'無 Others'}</option>
          </Input>
        </InputGroup>

        <InputGroup>                                                        
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="SIXTEEN_PLUS" id="SIXTEEN_PLUS"
            onChange={()=>{this.toggleCheckbox('SIXTEEN_PLUS')}}
            />
            <label class="form-check-label" for="SIXTEEN_PLUS">
              此故事只適合18歲或以上人士觀看
            </label>
          </div>
        </InputGroup>
        <InputGroup>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="SOUND" id="SOUND"
            onChange={()=>{this.toggleCheckbox('SOUND')}}
            />
            <label class="form-check-label" for="SOUND">
              此故事具音效
            </label>
          </div>
          
        </InputGroup>
        
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={this.onSubmit}>下一步</Button>
      </ModalFooter>
    </div>
    )
  }
}